import { QuestionTypeChip } from '@exam-management/components';
import { styled, Table, TableBody, TableCell, TableContainer, TableRow } from '@shared/components';

import { CALCULATION_TYPES, DIFFICULTY_LEVELS } from '../../constants';
import { FormNumberInputWithAlertError } from '../form-number-input-with-alert-error';

import { SingleQuestionConditionsTableHeader } from './single-question-conditions-table-header';

interface TableData {
  calculated: {
    easy?: number;
    medium?: number;
    hard?: number;
  };
  notCalculated: {
    easy?: number;
    medium?: number;
    hard?: number;
  };
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  '&:not(:last-of-type)': {
    borderRight: '1px solid',
    borderRightColor: theme.palette.grey[300],
  },
  borderColor: theme.palette.grey[300],
  padding: theme.spacing(2),
  fontWeight: 600,
}));

export interface SingleQuestionConditionsTableProps {
  data: TableData;
}

export default function SingleQuestionConditionsTable(
  props: Readonly<SingleQuestionConditionsTableProps>,
) {
  const { data } = props;

  return (
    <TableContainer
      sx={(theme) => ({
        borderRadius: theme.shape.rounded(2),
        overflow: 'hidden',
        border: '1px solid',
        borderColor: theme.palette.grey[800],
      })}
    >
      <Table
        sx={{
          border: 'none',
          borderCollapse: 'initial',
          mb: '-1px',
        }}
      >
        <SingleQuestionConditionsTableHeader />
        <TableBody>
          <TableRow>
            <StyledTableCell align='center'>
              <QuestionTypeChip type='single' />
            </StyledTableCell>
            {CALCULATION_TYPES.map((category) => {
              return DIFFICULTY_LEVELS.map((level) => (
                <StyledTableCell key={level} align='center'>
                  {data[category as keyof typeof data]?.[level as keyof typeof data.calculated] ??
                    '-'}
                </StyledTableCell>
              ));
            })}
          </TableRow>
          <TableRow>
            <StyledTableCell align='center'>กรอกจำนวนข้อ</StyledTableCell>
            {CALCULATION_TYPES.map((category) => {
              return DIFFICULTY_LEVELS.map((level) => (
                <StyledTableCell align='center' key={level}>
                  <FormNumberInputWithAlertError
                    name={`questionType.${category}.${level}`}
                    placeholder='0'
                    disabled={
                      !data[category as keyof typeof data]?.[level as keyof typeof data.calculated]
                    }
                    autoComplete='off'
                  />
                </StyledTableCell>
              ));
            })}
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}
